<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="web-nav">
      <p class="nav-title text-center">JP Nightアプリ掲載情報フォーム</p>
      <div class="nav-desc">
        <p>
          この度は、弊社アプリ「JP Night」への掲載をご検討いただき、誠にありがとうございます。<br />
          JP Nightは、ナイトタイムに営業されている店舗様の情報を掲載、最新のクラブ・フェス情報が集まるプラットフォームアプリです。
          ナイトシーンを盛り上げる店舗様の魅力をより多くのユーザーへ届けることを目的としております。
        </p>
        <p>
          現在、大阪観光局（OSAKA NIGHT OUT）とのタイアップにより、基本掲載料は無料でご案内しております。<br />
          また、店舗様のニーズに合わせてご活用いただける各種有料プランもご用意しております。
        </p>
        <p>
          加盟店情報入力フォームをお送りいただいた後、弊社よりご登録いただいたメールアドレスまたはお電話番号宛に担当者よりご連絡させていただきます。 <br />
          ご不明点やご相談がございましたら、下記までお気軽にお問い合わせください。
        </p>
        <p>
          株式会社JAPAN NIGHT<br />
          住所：大阪市中央区久太郎町2丁目5-19<br />
          電話番号：<a href="tel:0647087907">06-4708-7907</a>  <br />
          メールアドレス： <a href="mailto:contact@jp-night.com">contact@jp-night.com</a>
        </p>
        <p>
          詳しくは弊社HPよりご確認ください。<br />
          <a href="http://www.jp-night.com/"> http://www.jp-night.com/</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./css/pc.css";

@import "./css/ipad.css";
@import "./css/phone.css";
</style>
